// src/utils/imgSrc.js
const BASE = process.env.REACT_APP_API_BASE_URL ? process.env.REACT_APP_API_BASE_URL.replace(/\/$/, '') : '';

/**
 * Replace api.apt.com.co with apt.com.co in URLs for images
 * Images are hosted on api.apt.com.co but should be accessible via apt.com.co
 */
function replaceImageDomain(url) {
  if (!url || typeof url !== 'string') return url;
  // Replace api.apt.com.co with apt.com.co (case insensitive)
  return url.replace(/api\.apt\.com\.co/gi, 'apt.com.co');
}

/**
 * imgSrc(obj)
 * - obj: object that may contain img / image / image_url / icon (or a string)
 * - returns a resolved URL suitable for <img src="...">
 */
export function imgSrc(obj) {
  const defaultPath = '/images/41.png';

  // if a plain string was passed, treat it as the candidate
  const candidate = typeof obj === 'string'
    ? obj
    : (obj && (obj.img || obj.image || obj.image_url || obj.icon)) || defaultPath;

  // absolute URL (http(s) or protocol-relative)
  if (/^(https?:)?\/\//i.test(candidate)) {
    return replaceImageDomain(candidate);
  }

  // path starts with slash -> prefix base if available
  if (candidate.startsWith('/')) {
    const url = BASE ? `${BASE}${candidate}` : candidate;
    return replaceImageDomain(url);
  }

  // otherwise treat as relative filename
  const url = BASE ? `${BASE}/${candidate}` : candidate;
  return replaceImageDomain(url);
}

export default imgSrc;
